var map = {
	"./art/american-silence-the-photographs-of-robert-adams-robert-adams-10-31-2022": 1278,
	"./art/american-silence-the-photographs-of-robert-adams-robert-adams-10-31-2022.json": 1278,
	"./art/danish-and-international-art-after-1900-jens-søndergaard-emil-nolde-richard-mortensen-per-kirkeby-03-10-2023": 1691,
	"./art/danish-and-international-art-after-1900-jens-søndergaard-emil-nolde-richard-mortensen-per-kirkeby-03-10-2023.json": 1691,
	"./art/french-art-1900-1930-andré-derain-pablo-picasso-henri-matisse-georges-braque-raoul-dufy-03-10-2023": 9319,
	"./art/french-art-1900-1930-andré-derain-pablo-picasso-henri-matisse-georges-braque-raoul-dufy-03-10-2023.json": 9319,
	"./art/french-danish-20th-century-art-edvard-weie-paul-gaugin-pierre-bonnard-03-07-2023": 1494,
	"./art/french-danish-20th-century-art-edvard-weie-paul-gaugin-pierre-bonnard-03-07-2023.json": 1494,
	"./art/louisiana-museum-spring-2023-dana-schutz-richard-prince-gauri-gill-03-10-2023": 735,
	"./art/louisiana-museum-spring-2023-dana-schutz-richard-prince-gauri-gill-03-10-2023.json": 735,
	"./art/the-holsinger-studio-collection-rufus-holsinger-10-26-2022": 859,
	"./art/the-holsinger-studio-collection-rufus-holsinger-10-26-2022.json": 859,
	"./literature/a-day-in-the-country-and-other-stories-08-24-2024": 562,
	"./literature/a-day-in-the-country-and-other-stories-08-24-2024.json": 562,
	"./literature/a-farewell-to-arms-06-26-2023": 723,
	"./literature/a-farewell-to-arms-06-26-2023.json": 723,
	"./literature/a-tidewater-morning-04-13-2024": 8942,
	"./literature/a-tidewater-morning-04-13-2024.json": 8942,
	"./literature/absalom-absalom-11-24-2024": 6758,
	"./literature/absalom-absalom-11-24-2024.json": 6758,
	"./literature/alice-munro-selected-stories-1968-1994-06-26-2023": 6880,
	"./literature/alice-munro-selected-stories-1968-1994-06-26-2023.json": 6880,
	"./literature/babylon-revisited-and-other-stories-07-07-2025": 7311,
	"./literature/babylon-revisited-and-other-stories-07-07-2025.json": 7311,
	"./literature/black-spring-06-26-2023": 7440,
	"./literature/black-spring-06-26-2023.json": 7440,
	"./literature/brighton-rock-12-11-2023": 1560,
	"./literature/brighton-rock-12-11-2023.json": 1560,
	"./literature/chilly-scenes-of-winter-10-30-2024": 7907,
	"./literature/chilly-scenes-of-winter-10-30-2024.json": 7907,
	"./literature/dubliners--02-21-2023": 3878,
	"./literature/dubliners--02-21-2023.json": 3878,
	"./literature/enormous-changes-at-the-last-minute-05-27-2024": 1670,
	"./literature/enormous-changes-at-the-last-minute-05-27-2024.json": 1670,
	"./literature/ethan-frome--02-20-2023": 7058,
	"./literature/ethan-frome--02-20-2023.json": 7058,
	"./literature/fathers-and-sons-06-26-2023": 6765,
	"./literature/fathers-and-sons-06-26-2023.json": 6765,
	"./literature/first-love-last-rites-05-27-2024": 1401,
	"./literature/first-love-last-rites-05-27-2024.json": 1401,
	"./literature/greasy-lake-08-29-2026": 4817,
	"./literature/greasy-lake-08-29-2026.json": 4817,
	"./literature/i-cannot-tell-a-lie-exactly-02-14-2025": 9025,
	"./literature/i-cannot-tell-a-lie-exactly-02-14-2025.json": 9025,
	"./literature/jude-the-obscure-09-19-2025": 5143,
	"./literature/jude-the-obscure-09-19-2025.json": 5143,
	"./literature/knights-gambit-06-26-2023": 6878,
	"./literature/knights-gambit-06-26-2023.json": 6878,
	"./literature/lost-in-the-city-02-01-2025": 5768,
	"./literature/lost-in-the-city-02-01-2025.json": 5768,
	"./literature/loving-•-living-•-party-going-02-10-2026": 2044,
	"./literature/loving-•-living-•-party-going-02-10-2026.json": 2044,
	"./literature/miramar-11-21-2023": 6924,
	"./literature/miramar-11-21-2023.json": 6924,
	"./literature/nightmare-town-01-15-2025": 9038,
	"./literature/nightmare-town-01-15-2025.json": 9038,
	"./literature/nobodys-angel-03-27-2025": 4874,
	"./literature/nobodys-angel-03-27-2025.json": 4874,
	"./literature/nothing-•-doting-•-blindness-06-25-2025": 1989,
	"./literature/nothing-•-doting-•-blindness-06-25-2025.json": 1989,
	"./literature/of-mice-and-men-06-26-2023": 8489,
	"./literature/of-mice-and-men-06-26-2023.json": 8489,
	"./literature/open-city-06-26-2023": 5028,
	"./literature/open-city-06-26-2023.json": 5028,
	"./literature/out-of-this-world-06-11-2025": 1174,
	"./literature/out-of-this-world-06-11-2025.json": 1174,
	"./literature/paris-review-243-06-26-2023": 8875,
	"./literature/paris-review-243-06-26-2023.json": 8875,
	"./literature/paris-stories-07-15-2024": 5137,
	"./literature/paris-stories-07-15-2024.json": 5137,
	"./literature/rabbit-run-07-15-2024": 6705,
	"./literature/rabbit-run-07-15-2024.json": 6705,
	"./literature/red-harvest-03-03-2025": 2991,
	"./literature/red-harvest-03-03-2025.json": 2991,
	"./literature/sense-and-sensibility-08-18-2025": 6348,
	"./literature/sense-and-sensibility-08-18-2025.json": 6348,
	"./literature/sons-and-lovers-02-17-2025": 4003,
	"./literature/sons-and-lovers-02-17-2025.json": 4003,
	"./literature/summer-03-07-2025": 5772,
	"./literature/summer-03-07-2025.json": 5772,
	"./literature/tenth-of-december-01-20-2024": 6807,
	"./literature/tenth-of-december-01-20-2024.json": 6807,
	"./literature/the-big-sleep-04-18-2025": 2864,
	"./literature/the-big-sleep-04-18-2025.json": 2864,
	"./literature/the-brothers-karamazov-11-14-2023": 5791,
	"./literature/the-brothers-karamazov-11-14-2023.json": 5791,
	"./literature/the-chekhov-omnibus-selected-stories-01-19-2024": 2623,
	"./literature/the-chekhov-omnibus-selected-stories-01-19-2024.json": 2623,
	"./literature/the-day-of-the-owl-03-04-2025": 4964,
	"./literature/the-day-of-the-owl-03-04-2025.json": 4964,
	"./literature/the-dew-breaker-06-26-2023": 9671,
	"./literature/the-dew-breaker-06-26-2023.json": 9671,
	"./literature/the-end-of-the-affair-09-07-2023": 2169,
	"./literature/the-end-of-the-affair-09-07-2023.json": 2169,
	"./literature/the-heart-of-the-matter-06-26-2023": 813,
	"./literature/the-heart-of-the-matter-06-26-2023.json": 813,
	"./literature/the-house-of-mirth-06-26-2023": 6671,
	"./literature/the-house-of-mirth-06-26-2023.json": 6671,
	"./literature/the-lady-in-the-lake-•-the-little-sister-•-the-long-goodbye-•-playback-11-24-2025": 3740,
	"./literature/the-lady-in-the-lake-•-the-little-sister-•-the-long-goodbye-•-playback-11-24-2025.json": 3740,
	"./literature/the-new-york-trilogy-10-14-2025": 4588,
	"./literature/the-new-york-trilogy-10-14-2025.json": 4588,
	"./literature/the-old-forest-and-other-stories-06-13-2026": 4442,
	"./literature/the-old-forest-and-other-stories-06-13-2026.json": 4442,
	"./literature/the-old-man-and-the-sea-11-09-2023": 2849,
	"./literature/the-old-man-and-the-sea-11-09-2023.json": 2849,
	"./literature/the-penguin-book-of-modern-british-short-stories-06-26-2023": 1488,
	"./literature/the-penguin-book-of-modern-british-short-stories-06-26-2023.json": 1488,
	"./literature/the-power-and-the-glory--02-26-2023": 8039,
	"./literature/the-power-and-the-glory--02-26-2023.json": 8039,
	"./literature/the-prime-of-miss-jean-brodie-12-05-2023": 3669,
	"./literature/the-prime-of-miss-jean-brodie-12-05-2023.json": 3669,
	"./literature/the-scarlet-letter-02-25-2024": 9513,
	"./literature/the-scarlet-letter-02-25-2024.json": 9513,
	"./literature/the-stranger--11-12-2022": 1179,
	"./literature/the-stranger--11-12-2022.json": 1179,
	"./literature/the-sun-also-rises-06-26-2023": 3480,
	"./literature/the-sun-also-rises-06-26-2023.json": 3480,
	"./literature/the-things-they-carried-01-20-2024": 5155,
	"./literature/the-things-they-carried-01-20-2024.json": 5155,
	"./literature/the-vets-daughter-05-27-2024": 8871,
	"./literature/the-vets-daughter-05-27-2024.json": 8871,
	"./literature/the-waves-04-25-2023": 9371,
	"./literature/the-waves-04-25-2023.json": 9371,
	"./literature/the-woodlanders-03-17-2024": 8828,
	"./literature/the-woodlanders-03-17-2024.json": 8828,
	"./literature/thomas-hardy-the-withered-arm-and-other-stories--01-04-2023": 8095,
	"./literature/thomas-hardy-the-withered-arm-and-other-stories--01-04-2023.json": 8095,
	"./literature/to-the-north-06-26-2026": 5417,
	"./literature/to-the-north-06-26-2026.json": 5417,
	"./literature/train-dreams-08-04-2024": 7373,
	"./literature/train-dreams-08-04-2024.json": 7373,
	"./literature/twenty-one-stories-01-19-2024": 1779,
	"./literature/twenty-one-stories-01-19-2024.json": 1779,
	"./literature/two-nurses-smoking-01-19-2024": 4301,
	"./literature/two-nurses-smoking-01-19-2024.json": 4301,
	"./literature/warlight-10-04-2024": 8618,
	"./literature/warlight-10-04-2024.json": 8618,
	"./memes/my-honest-reaction-03-29-2023": 9036,
	"./memes/my-honest-reaction-03-29-2023.json": 9036,
	"./movies/12-angry-men-09-11-2024": 3330,
	"./movies/12-angry-men-09-11-2024.json": 3330,
	"./movies/2001-a-space-odyssey-09-06-2023": 516,
	"./movies/2001-a-space-odyssey-09-06-2023.json": 516,
	"./movies/a-tale-of-autumn-05-25-2024": 5763,
	"./movies/a-tale-of-autumn-05-25-2024.json": 5763,
	"./movies/a-tale-of-winter-05-19-2023": 1624,
	"./movies/a-tale-of-winter-05-19-2023.json": 1624,
	"./movies/aftersun-03-27-2023": 54,
	"./movies/aftersun-03-27-2023.json": 54,
	"./movies/along-the-great-divide-04-15-2025": 2752,
	"./movies/along-the-great-divide-04-15-2025.json": 2752,
	"./movies/brighton-rock--02-04-2023": 1866,
	"./movies/brighton-rock--02-04-2023.json": 1866,
	"./movies/bring-them-down-06-23-2025": 5487,
	"./movies/bring-them-down-06-23-2025.json": 5487,
	"./movies/brute-force-08-25-2024": 6818,
	"./movies/brute-force-08-25-2024.json": 6818,
	"./movies/bullet-train-sony-pictures-entertainment-08-10-2022": 7883,
	"./movies/bullet-train-sony-pictures-entertainment-08-10-2022.json": 7883,
	"./movies/chinatown-09-12-2025": 3299,
	"./movies/chinatown-09-12-2025.json": 3299,
	"./movies/donnie-darko-09-13-2023": 1274,
	"./movies/donnie-darko-09-13-2023.json": 1274,
	"./movies/dr-strangelove-or-how-i-learned-to-stop-worrying-and-love-the-bomb-04-22-2024": 2961,
	"./movies/dr-strangelove-or-how-i-learned-to-stop-worrying-and-love-the-bomb-04-22-2024.json": 2961,
	"./movies/five-easy-pieces-09-02-2024": 3644,
	"./movies/five-easy-pieces-09-02-2024.json": 3644,
	"./movies/friendship-06-16-2025": 8521,
	"./movies/friendship-06-16-2025.json": 8521,
	"./movies/godland--11-10-2022": 9760,
	"./movies/godland--11-10-2022.json": 9760,
	"./movies/good-will-hunting-06-16-2025": 7967,
	"./movies/good-will-hunting-06-16-2025.json": 7967,
	"./movies/great-expectations--02-04-2023": 245,
	"./movies/great-expectations--02-04-2023.json": 245,
	"./movies/green-for-danger-11-04-2023": 9698,
	"./movies/green-for-danger-11-04-2023.json": 9698,
	"./movies/gun-crazy-04-03-2024": 1261,
	"./movies/gun-crazy-04-03-2024.json": 1261,
	"./movies/high-noon-04-07-2025": 2294,
	"./movies/high-noon-04-07-2025.json": 2294,
	"./movies/i-confess-10-06-2024": 6799,
	"./movies/i-confess-10-06-2024.json": 6799,
	"./movies/ikiru--01-04-2023": 1923,
	"./movies/ikiru--01-04-2023.json": 1923,
	"./movies/kagemusha--01-13-2023": 3283,
	"./movies/kagemusha--01-13-2023.json": 3283,
	"./movies/killers-of-the-flower-moon-11-10-2023": 1173,
	"./movies/killers-of-the-flower-moon-11-10-2023.json": 1173,
	"./movies/knife-in-the-water-02-13-2024": 3657,
	"./movies/knife-in-the-water-02-13-2024.json": 3657,
	"./movies/knives-out-2--01-04-2023": 1276,
	"./movies/knives-out-2--01-04-2023.json": 1276,
	"./movies/l-a-confidential-06-17-2024": 3073,
	"./movies/l-a-confidential-06-17-2024.json": 3073,
	"./movies/la-dolce-vita-10-02-2024": 1094,
	"./movies/la-dolce-vita-10-02-2024.json": 1094,
	"./movies/la-ronde--02-04-2023": 5455,
	"./movies/la-ronde--02-04-2023.json": 5455,
	"./movies/licorice-pizza--01-04-2023": 746,
	"./movies/licorice-pizza--01-04-2023.json": 746,
	"./movies/little-children--10-04-2022": 831,
	"./movies/little-children--10-04-2022.json": 831,
	"./movies/love-in-the-afternoon-08-29-2023": 1081,
	"./movies/love-in-the-afternoon-08-29-2023.json": 1081,
	"./movies/m3gan--01-13-2023": 4946,
	"./movies/m3gan--01-13-2023.json": 4946,
	"./movies/macao-04-15-2024": 4982,
	"./movies/macao-04-15-2024.json": 4982,
	"./movies/madeleine-09-14-2023": 7626,
	"./movies/madeleine-09-14-2023.json": 7626,
	"./movies/marshland-05-19-2025": 6085,
	"./movies/marshland-05-19-2025.json": 6085,
	"./movies/mccabe-mrs-miller-09-12-2025": 6366,
	"./movies/mccabe-mrs-miller-09-12-2025.json": 6366,
	"./movies/night-moves-02-03-2024": 1381,
	"./movies/night-moves-02-03-2024.json": 1381,
	"./movies/nightmare-alley--10-04-2022": 2533,
	"./movies/nightmare-alley--10-04-2022.json": 2533,
	"./movies/notorious--02-04-2023": 9238,
	"./movies/notorious--02-04-2023.json": 9238,
	"./movies/oceans-eleven-06-16-2025": 8823,
	"./movies/oceans-eleven-06-16-2025.json": 8823,
	"./movies/on-dangerous-ground-11-05-2024": 4200,
	"./movies/on-dangerous-ground-11-05-2024.json": 4200,
	"./movies/panic-in-the-streets-11-15-2023": 9403,
	"./movies/panic-in-the-streets-11-15-2023.json": 9403,
	"./movies/paris-texas-08-24-2023": 3057,
	"./movies/paris-texas-08-24-2023.json": 3057,
	"./movies/paths-of-glory-11-03-2023": 5093,
	"./movies/paths-of-glory-11-03-2023.json": 5093,
	"./movies/pickpocket-11-10-2023": 6845,
	"./movies/pickpocket-11-10-2023.json": 6845,
	"./movies/pollock--11-29-2022": 3841,
	"./movies/pollock--11-29-2022.json": 3841,
	"./movies/poor-things-05-29-2024": 7245,
	"./movies/poor-things-05-29-2024.json": 7245,
	"./movies/portrait-of-a-lady-on-fire-02-16-2024": 6042,
	"./movies/portrait-of-a-lady-on-fire-02-16-2024.json": 6042,
	"./movies/radiohead-creep-live-at-reading-festival-2009-03-17-2024": 3129,
	"./movies/radiohead-creep-live-at-reading-festival-2009-03-17-2024.json": 3129,
	"./movies/ran--01-13-2023": 3492,
	"./movies/ran--01-13-2023.json": 3492,
	"./movies/rear-window-12-28-2023": 9202,
	"./movies/rear-window-12-28-2023.json": 9202,
	"./movies/red-beard--02-04-2023": 5952,
	"./movies/red-beard--02-04-2023.json": 5952,
	"./movies/see-how-they-run--10-04-2022": 9077,
	"./movies/see-how-they-run--10-04-2022.json": 9077,
	"./movies/sexy-beast-02-15-2024": 4136,
	"./movies/sexy-beast-02-15-2024.json": 4136,
	"./movies/shutter-island-06-16-2025": 230,
	"./movies/shutter-island-06-16-2025.json": 230,
	"./movies/stage-fright-08-22-2023": 9977,
	"./movies/stage-fright-08-22-2023.json": 9977,
	"./movies/stranger-than-paradise-04-30-2023": 1810,
	"./movies/stranger-than-paradise-04-30-2023.json": 1810,
	"./movies/suspicion-09-24-2024": 8201,
	"./movies/suspicion-09-24-2024.json": 8201,
	"./movies/the-assassination-of-jesse-james-by-the-coward-robert-ford-08-30-2023": 7678,
	"./movies/the-assassination-of-jesse-james-by-the-coward-robert-ford-08-30-2023.json": 7678,
	"./movies/the-big-city-10-13-2024": 5792,
	"./movies/the-big-city-10-13-2024.json": 5792,
	"./movies/the-big-lebowski-12-26-2024": 7437,
	"./movies/the-big-lebowski-12-26-2024.json": 7437,
	"./movies/the-blue-dahlia--11-08-2022": 9872,
	"./movies/the-blue-dahlia--11-08-2022.json": 9872,
	"./movies/the-brutalist-01-28-2025": 874,
	"./movies/the-brutalist-01-28-2025.json": 874,
	"./movies/the-comfort-of-strangers-06-02-2024": 6030,
	"./movies/the-comfort-of-strangers-06-02-2024.json": 6030,
	"./movies/the-lady-vanishes-09-06-2023": 5940,
	"./movies/the-lady-vanishes-09-06-2023.json": 5940,
	"./movies/the-last-wave-11-12-2024": 7785,
	"./movies/the-last-wave-11-12-2024.json": 7785,
	"./movies/the-man-who-knew-too-much--02-04-2023": 9837,
	"./movies/the-man-who-knew-too-much--02-04-2023.json": 9837,
	"./movies/the-menu--01-04-2023": 2813,
	"./movies/the-menu--01-04-2023.json": 2813,
	"./movies/the-phoenician-scheme-06-16-2025": 3187,
	"./movies/the-phoenician-scheme-06-16-2025.json": 3187,
	"./movies/the-piano-teacher--10-04-2022": 1510,
	"./movies/the-piano-teacher--10-04-2022.json": 1510,
	"./movies/the-revenant--03-07-2023": 1234,
	"./movies/the-revenant--03-07-2023.json": 1234,
	"./movies/the-rules-of-the-game--03-13-2023": 6247,
	"./movies/the-rules-of-the-game--03-13-2023.json": 6247,
	"./movies/the-searchers-05-01-2024": 9618,
	"./movies/the-searchers-05-01-2024.json": 9618,
	"./movies/the-spy-who-came-in-from-the-cold--09-10-2022": 9849,
	"./movies/the-spy-who-came-in-from-the-cold--09-10-2022.json": 9849,
	"./movies/the-sting--01-13-2023": 483,
	"./movies/the-sting--01-13-2023.json": 483,
	"./movies/the-third-man-11-30-2023": 5216,
	"./movies/the-third-man-11-30-2023.json": 5216,
	"./movies/the-tree-of-life--10-31-2022": 4390,
	"./movies/the-tree-of-life--10-31-2022.json": 4390,
	"./movies/the-wages-of-fear-08-22-2023": 6605,
	"./movies/the-wages-of-fear-08-22-2023.json": 6605,
	"./movies/the-wild-bunch-02-01-2024": 1181,
	"./movies/the-wild-bunch-02-01-2024.json": 1181,
	"./movies/vincent-theo-09-02-2025": 4024,
	"./movies/vincent-theo-09-02-2025.json": 4024,
	"./movies/warfare-09-12-2025": 9175,
	"./movies/warfare-09-12-2025.json": 9175,
	"./movies/weapons-09-02-2025": 7190,
	"./movies/weapons-09-02-2025.json": 7190,
	"./movies/witness-for-the-prosecution--01-04-2023": 3997,
	"./movies/witness-for-the-prosecution--01-04-2023.json": 3997,
	"./movies/zero-dark-thirty--10-25-2022": 8346,
	"./movies/zero-dark-thirty--10-25-2022.json": 8346,
	"./museums/test-museum-03-23-2023": 2142,
	"./museums/test-museum-03-23-2023.json": 2142,
	"./music/april-mixtape-ep-the-snow-strippers-april-mixtape-2-april-mixtape-3-night-killaz-vol-1-11-25-2023": 6235,
	"./music/april-mixtape-ep-the-snow-strippers-april-mixtape-2-april-mixtape-3-night-killaz-vol-1-11-25-2023.json": 6235,
	"./music/astronaut-lingo-3-10-29-2023": 415,
	"./music/astronaut-lingo-3-10-29-2023.json": 415,
	"./music/balance-mixtape-02-06-2024": 5492,
	"./music/balance-mixtape-02-06-2024.json": 5492,
	"./music/bladee-gluee-bladee-10-15-2022": 8136,
	"./music/bladee-gluee-bladee-10-15-2022.json": 8136,
	"./music/bladee-icedancer-bladee-10-26-2022": 4326,
	"./music/bladee-icedancer-bladee-10-26-2022.json": 4326,
	"./music/car-country-10-08-2025": 4669,
	"./music/car-country-10-08-2025.json": 4669,
	"./music/cd-r-06-03-2024": 464,
	"./music/cd-r-06-03-2024.json": 464,
	"./music/clockwise-10-28-2023": 6356,
	"./music/clockwise-10-28-2023.json": 6356,
	"./music/computerwife-08-15-2023": 1135,
	"./music/computerwife-08-15-2023.json": 1135,
	"./music/david-shawty-david-3-david-shawty-10-31-2022": 2098,
	"./music/david-shawty-david-3-david-shawty-10-31-2022.json": 2098,
	"./music/entre-los-dos-y-la-bamba-02-05-2023": 4266,
	"./music/entre-los-dos-y-la-bamba-02-05-2023.json": 4266,
	"./music/everyone-is-a-light-10-29-2023": 7700,
	"./music/everyone-is-a-light-10-29-2023.json": 7700,
	"./music/flasher-love-is-yours-flasher-12-21-2022": 5335,
	"./music/flasher-love-is-yours-flasher-12-21-2022.json": 5335,
	"./music/give-up-baby-go-peach-pit-08-10-2022": 6860,
	"./music/give-up-baby-go-peach-pit-08-10-2022.json": 6860,
	"./music/guise-bleary-eyed-02-04-2023": 5730,
	"./music/guise-bleary-eyed-02-04-2023.json": 5730,
	"./music/her-loss-drake-21-savage-drake-21-savage-11-04-2022": 2385,
	"./music/her-loss-drake-21-savage-drake-21-savage-11-04-2022.json": 2385,
	"./music/i-will-never-learn-10-28-2023": 1062,
	"./music/i-will-never-learn-10-28-2023.json": 1062,
	"./music/inch-buzzer-ep-inch-11-07-2022": 4895,
	"./music/inch-buzzer-ep-inch-11-07-2022.json": 4895,
	"./music/insecurity-breach-something-to-look-forward-to-hooky-hooky-03-07-2023": 2942,
	"./music/insecurity-breach-something-to-look-forward-to-hooky-hooky-03-07-2023.json": 2942,
	"./music/is-it-light-out-where-you-are-ep-08-14-2023": 3726,
	"./music/is-it-light-out-where-you-are-ep-08-14-2023.json": 3726,
	"./music/lerado-khalil-uhh-lerado-khalil-12-13-2022": 16,
	"./music/lerado-khalil-uhh-lerado-khalil-12-13-2022.json": 16,
	"./music/lowertown-love-to-lie-lowertown-10-26-2022": 6200,
	"./music/lowertown-love-to-lie-lowertown-10-26-2022.json": 6200,
	"./music/mirage-01-25-2024": 3709,
	"./music/mirage-01-25-2024.json": 3709,
	"./music/mistake-10-28-2023": 2020,
	"./music/mistake-10-28-2023.json": 2020,
	"./music/mtvh1n1-mtvh1n1-02-04-2023": 8674,
	"./music/mtvh1n1-mtvh1n1-02-04-2023.json": 8674,
	"./music/no-color-02-25-2024": 7017,
	"./music/no-color-02-25-2024.json": 7017,
	"./music/only-god-was-above-us-04-07-2024": 439,
	"./music/only-god-was-above-us-04-07-2024.json": 439,
	"./music/pet-shimmers-anon-playable-cloud-pet-shimmers-12-23-2022": 4862,
	"./music/pet-shimmers-anon-playable-cloud-pet-shimmers-12-23-2022.json": 4862,
	"./music/phoenix-wolfgang-aamadeus-phoenix-phoenix-10-03-2022": 3623,
	"./music/phoenix-wolfgang-aamadeus-phoenix-phoenix-10-03-2022.json": 3623,
	"./music/pinback-blue-screen-life-pinback-12-13-2022": 3085,
	"./music/pinback-blue-screen-life-pinback-12-13-2022.json": 3085,
	"./music/primitive-tech-tek-lintowe-woody-01-31-2023": 7638,
	"./music/primitive-tech-tek-lintowe-woody-01-31-2023.json": 7638,
	"./music/race-full-album-slowed-reverb-11-01-2023": 5430,
	"./music/race-full-album-slowed-reverb-11-01-2023.json": 5430,
	"./music/skepta-chip-young-adz-insomnia-skepta-chip-young-adz-12-21-2022": 4937,
	"./music/skepta-chip-young-adz-insomnia-skepta-chip-young-adz-12-21-2022.json": 4937,
	"./music/sleater-kinney-the-hot-rock-sleater-kinney-12-21-2022": 1493,
	"./music/sleater-kinney-the-hot-rock-sleater-kinney-12-21-2022.json": 1493,
	"./music/slow-rock-09-12-2025": 9576,
	"./music/slow-rock-09-12-2025.json": 9576,
	"./music/softie-strong-hold-softie-10-03-2022": 2418,
	"./music/softie-strong-hold-softie-10-03-2022.json": 2418,
	"./music/somewhere-down-below-08-14-2023": 4702,
	"./music/somewhere-down-below-08-14-2023.json": 4702,
	"./music/swanlike-loosies-2020-2023-07-01-2024": 5842,
	"./music/swanlike-loosies-2020-2023-07-01-2024.json": 5842,
	"./music/the-cradle-radio-wars-the-cradle-10-03-2022": 6178,
	"./music/the-cradle-radio-wars-the-cradle-10-03-2022.json": 6178,
	"./music/the-sea-and-cake-the-fawn-the-sea-and-cake-12-21-2022": 7204,
	"./music/the-sea-and-cake-the-fawn-the-sea-and-cake-12-21-2022.json": 7204,
	"./music/the-simps-siblings-the-simps-12-21-2022": 329,
	"./music/the-simps-siblings-the-simps-12-21-2022.json": 329,
	"./music/tonstartsbandht-an-when-tonstartsbandht-12-21-2022": 3441,
	"./music/tonstartsbandht-an-when-tonstartsbandht-12-21-2022.json": 3441,
	"./music/tony-shhnow-dis-should-hold-u-over-tony-shhnow-12-21-2022": 1430,
	"./music/tony-shhnow-dis-should-hold-u-over-tony-shhnow-12-21-2022.json": 1430,
	"./music/tyler-the-creator-igor-tyler-the-creator-12-21-2022": 9689,
	"./music/tyler-the-creator-igor-tyler-the-creator-12-21-2022.json": 9689,
	"./music/ulrika-spacek-modern-english-decoration-ulrika-spacek-12-21-2022": 3020,
	"./music/ulrika-spacek-modern-english-decoration-ulrika-spacek-12-21-2022.json": 3020,
	"./music/vampire-weekend-contra-vampire-weekend-11-15-2022": 4399,
	"./music/vampire-weekend-contra-vampire-weekend-11-15-2022.json": 4399,
	"./music/vampire-weekend-vampire-weekend-vampire-weekend-12-21-2022": 5889,
	"./music/vampire-weekend-vampire-weekend-vampire-weekend-12-21-2022.json": 5889,
	"./music/young-thug-slime-season-2-young-thug-12-13-2022": 739,
	"./music/young-thug-slime-season-2-young-thug-12-13-2022.json": 739,
	"./music/young-thug-slime-season-3-young-thug-11-12-2022": 3834,
	"./music/young-thug-slime-season-3-young-thug-11-12-2022.json": 3834,
	"./music/young-thug-slime-season-young-thug-11-15-2022": 3698,
	"./music/young-thug-slime-season-young-thug-11-15-2022.json": 3698,
	"./songs/a-minute-or-2-01-01-2024": 4288,
	"./songs/a-minute-or-2-01-01-2024.json": 4288,
	"./songs/bigger-man-01-01-2024": 5970,
	"./songs/bigger-man-01-01-2024.json": 5970,
	"./songs/each-year-05-28-2024": 3737,
	"./songs/each-year-05-28-2024.json": 3737,
	"./songs/everything-01-01-2024": 4566,
	"./songs/everything-01-01-2024.json": 4566,
	"./songs/freak-out-01-01-2024": 7699,
	"./songs/freak-out-01-01-2024.json": 7699,
	"./songs/it-aint-nun-feat-nbt-motion-01-01-2024": 7593,
	"./songs/it-aint-nun-feat-nbt-motion-01-01-2024.json": 7593,
	"./songs/kind-01-01-2024": 4553,
	"./songs/kind-01-01-2024.json": 4553,
	"./songs/mortified-feat-jack-zebra-05-28-2024": 3102,
	"./songs/mortified-feat-jack-zebra-05-28-2024.json": 3102,
	"./songs/treat-myself-05-28-2024": 5658,
	"./songs/treat-myself-05-28-2024-1": 6980,
	"./songs/treat-myself-05-28-2024-1.json": 6980,
	"./songs/treat-myself-05-28-2024.json": 5658,
	"./tv/mad-men-07-23-2025": 6926,
	"./tv/mad-men-07-23-2025.json": 6926,
	"./tv/mare-of-easttown-12-30-2023": 2225,
	"./tv/mare-of-easttown-12-30-2023.json": 2225,
	"./tv/tinker-tailor-soldier-spy-05-04-2024": 2259,
	"./tv/tinker-tailor-soldier-spy-05-04-2024.json": 2259
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9280;